import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, GLMKiloFlow, GLMKiloFlowUpdate } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateGLMKiloFlow(): UseMutationResult<
  AxiosResponse<GLMKiloFlow>,
  AxiosError<ErrorMessage>,
  GLMKiloFlowUpdate
> {
  const queryClient = useQueryClient();

  const updateGLMKiloFlow = useCallback((flow: GLMKiloFlowUpdate): Promise<AxiosResponse<GLMKiloFlow>> => {
    return client.put(`glm-kilo-flows/${flow.glmKiloFlowId}/`, flow);
  }, []);

  return useMutation(updateGLMKiloFlow, {
    onSuccess: () => {
      queryClient.invalidateQueries('glm-kilo-flows');
    },
  });
}
